export const dmarcResults = {
    "title": "DMARC Analyse-Ergebnis",
    "previewInfo": "Hier ist ein Überblick über die Ergebnisse deiner Analyse.",
    "score": "Gesamtscore",
    "mechanisms": "DMARC-Einträge",
    "warningHeader": "Warnungen",
    "issueHeader": "Probleme",
    "partialDisclosure": "Dies ist eine Vorschau. Weitere Details findest du im vollständigen Bericht.",
    "reportPitch": "Trage deine E-Mail-Adresse ein, um den vollständigen Bericht zu erhalten.",
    "emailLabel": "E-Mail-Adresse",
    "emailPlaceholder": "z.B. max@example.com",
    "getFullReport": "Vollständigen Bericht erhalten",
    "emailDisclaimer": "Wir senden dir den Bericht einmalig per E-Mail. Kein Spam.",
    "fomoFact": "✅ Über 1.000 Domains wurden schon analysiert!",
    "fomoPitch": "Verpasse nicht deine Chance, deine Domain optimal abzusichern. Unsere Nutzer sparen im Schnitt 12 Supportstunden pro Monat!",
    "getStarted": "Jetzt registrieren",
    warnings: {
        DMARC_WARN_INVALID_SEGMENT: "⚠️ Invalid DMARC segment entry",
        DMARC_WARN_DUPLICATE_TAG: "⚠️ Duplicate tag found: {{value}}",
        DMARC_WARN_P_NOT_REJECT: "⚠️ Policy is not set to 'reject': {{value}}",
        DMARC_WARN_RUA_NO_MAILTO: "⚠️ RUA address does not contain 'mailto:'",
        DMARC_WARN_INVALID_RUA: "⚠️ Invalid email address in RUA",
        DMARC_WARN_RUF_NO_MAILTO: "⚠️ RUF address does not contain 'mailto:'",
        DMARC_WARN_INVALID_RUF: "⚠️ Invalid email address in RUF",
        DMARC_WARN_SP_NOT_REJECT: "⚠️ 'sp' is not set to 'reject': {{value}}",
        DMARC_WARN_INVALID_PCT: "⚠️ Invalid 'pct' value: {{value}}",
        DMARC_WARN_RI_TOO_LOW: "⚠️ RI value is too low: {{value}}",
        DMARC_WARN_RI_TOO_HIGH: "⚠️ RI value is too high: {{value}}"
    },
    issues: {
        INVALID_DMARC_VERSION: "❌ Invalid DMARC version: {{value}}",
        DMARC_ERR_INVALID_P: "❌ Invalid value for 'p': {{value}}",
        DMARC_ERR_MISSING_SP: "❌ Missing 'sp' tag",
        UNKNOWN_ENTRY: "❌ Unknown entry: {{value}}",
        MISSING_DMARC_VERSION_DEFINITION: "❌ Missing DMARC version (v=)",
        MISSING_DMARC_POLICY_DEFINITION: "❌ Missing DMARC policy (p=)",
        DMARC_ERR_INVALID_RI: "❌ Invalid RI Value: {{value}}",
        DMARC_ERR_INVALID_FO: "❌ Invalid FO Value: {{value}}",
        DMARC_ERR_INVALID_ADKIM: "❌ Invalid Adkim Value: {{value}}",
        DMARC_ERR_INVALID_ASPF: "❌ Invalid Aspf Value: {{value}}"
    }
};



